<div class="verification-container">
  <div class="verification-container__header">
    <div class="verification-container__header-title">FedEx Account Verification</div>
    <div class="close-icon">
      <img alt="Close dialog" (click)="onClose()" src="assets/icons/x-delivery-services.svg" />
    </div>
  </div>

  <div class="verification-container__body">
    <p class="verification-container__text">A verification code has been sent via {{ getMethodDisplayName() }}.</p>
    <p class="verification-container__label">Enter your 6-digit PIN:</p>
    <pdq-input-code-verification [length]="6" [disabled]="isLoading" (codeComplete)="onPinComplete($event)">
    </pdq-input-code-verification>
    <div class="verification-container__resend">
      <span>Didn't receive it?</span>
      <button class="resend-link" (click)="onResend()">Resend Code</button>
    </div>
  </div>

  @if (errorMessage) {
  <div class="verification-container__error">{{ errorMessage }}</div>
  }

  <div class="verification-container__actions">
    <pdq-button variant="secondary" (onClick)="onClose()" label="Cancel"></pdq-button>
    <pdq-button
      variant="primary"
      (onClick)="onVerify()"
      [disabled]="!canSubmit || isLoading"
      [label]="isLoading ? 'Verifying...' : 'Verify'">
    </pdq-button>
  </div>
</div>
